module.exports = __webpack_public_path__ + "static/media/louvre-grand-sphinx-tanis-detail.2e5729ac.jpg";